module.exports = __webpack_public_path__ + "media/images/Collage-87c14ace.jpg";